import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const TableOfContents = () => {
    const [tocLinks, setTocLinks] = useState([]);
    const [isVisible, setIsVisible] = useState(true);
    const [parentElement, setParentElement] = useState(null);

    useEffect(() => {
        const blogContainer = document.querySelector(".blog-texts");
        if (!blogContainer) return;

        const links = blogContainer.querySelectorAll("a[href^='#']");
        if (links.length === 0) return;

        const tocItems = Array.from(links).map((link, index) => ({
            id: link.getAttribute("href"),
            text: link.innerText || `Bölüm ${index + 1}`,
        }));

        setTocLinks(tocItems);

        // Find and set the first link's parent element
        const firstLinkParent = links[0].parentElement;
        if (firstLinkParent) {
            setParentElement(firstLinkParent);
        }

        // Remove all link parents
        links.forEach(link => {
            link.remove();
            if (link.parentElement !== firstLinkParent) {
                const parentElement = link.parentElement;
                if (parentElement) parentElement.remove();
            }
        });
    }, []);

    if (tocLinks.length === 0 || !parentElement) return null;

    const tocContent = (
        <div id="table-of-contents" className={`toc-container ${isVisible ? "expanded bg-light" : ""} my-3`}>
            <button className="toggle-btn" onClick={() => setIsVisible(!isVisible)}>
                {isVisible ? "İçindekileri Gizle" : "İçindekileri Göster"}
            </button>
            <div className={`toc-content ${isVisible ? "show mt-2 px-1" : "hide"}`}>
                <ul>
                    {tocLinks.map((item, index) => (
                        <li key={index}>
                            <a className="text-orange" href={item.id}>{item.text}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );

    // Render the component inside the first link's parent
    return createPortal(tocContent, parentElement);
};

export default TableOfContents;
